import React, { createContext, useContext, useState } from "react";

const MaintenanceContext = createContext();

export const MaintenanceProvider = ({ children }) => {
  const [isMaintenance, setIsMaintenance] = useState(false);

  const setMaintenance = (value) => {
    setIsMaintenance(value);
  };

  return (
    <MaintenanceContext.Provider value={{ isMaintenance, setMaintenance }}>
      {children}
    </MaintenanceContext.Provider>
  );
};

export const useMaintenance = () => useContext(MaintenanceContext);